module.exports = __webpack_public_path__ + "static/01-068b5a4f10a7352a28e265778d5d964a.jpg";